import {
  IBasePagingRes,
  IBaseResponseModel,
} from "../../models/common/models.type";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import { EContentResponse, ESeoResponse } from "../../models/seo";
import { EBlogResponse, IBlogGetPage } from "../../models/blog";
import { EPageResponse, IPageGetPage } from "../../models/page";
import { FaqItem } from "../../models/faq";
import { ToneItem } from "../../models/tone";

const API = ApiEndpoints.Tone;
const baseURL = envConfig.API_ENDPOINT;

const getAll = async (
  language: string,
): Promise<IBaseResponseModel<ToneItem[]>> => {
  return api.get(baseURL, API.GetAll.url + "?language=" + language);
  //return res;
};

const createOrUpdate = async (
  data: any,
): Promise<IBaseResponseModel<ToneItem[]>> => {
  return api.put(baseURL, API.CreateOrUpdate.url, data);
  //return res;
};

const ToneService = {
  getAll,
  createOrUpdate,
};

export default ToneService;
